export class PurchaseOrder {
  constructor(id: string, purchaseOrder: string) {
    this.id = id;
    this.purchaseOrder = purchaseOrder;
  }
  id!: string | null;
  purchaseOrder?: string;
}